import { Component, OnInit } from '@angular/core';
import { LessonCardHomePageComponent } from '../lesson-card-home-page/lesson-card-home-page.component';
import { DwComponent, DwComponentType, DwMetaDataListCardConfigData } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames } from '../../../../../meta-data/app-meta-data.service';

@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Lesson Card - Home Page 2',
  key: 'lessonCard-homePage2',
  componentType: DwComponentType.card,
  //configComponent: DwCardDefaultConfigComponent,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.CourseLesson,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})
@Component({
  selector: 'app-lesson-card-home-page2',
  templateUrl: './lesson-card-home-page2.component.html',
  styleUrls: ['./lesson-card-home-page2.component.scss']
})
export class LessonCardHomePage2Component extends LessonCardHomePageComponent {

  imageWidth = 545;
  imageHeight = 308;
  
  getLessonUrl() {
    return this.courseRepositoryService.getLessonImageUrl(this.data, this.imageWidth, this.imageHeight); 
  }
}
